import React, {useState, useEffect} from 'react';
import styles from './reject-sales-report-modal-content.module.scss';
import {Button, Col, Row, Spinner} from "react-bootstrap";
import SecurityService from "../../../../../../services/security-service";

const RejectSalesReportModalContent = ({securityId, entityId, onClose, onSuccess}) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const securityService = new SecurityService();
  console.log(entityId);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        window.location.reload();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleReject = async () => {
    setLoading(true);
    setError(null);
    try {
      await securityService.adcuRejectSecurityOffer(securityId, entityId);
      setSuccess(true);
      if (onSuccess) onSuccess();
    } catch(error) {
      setError(error.message|| 'Failed to reject sales report');
      setLoading(false);
    }
  }

  const handleClose = () => {
    if (success) {
      window.location.reload();
    } else {
      onClose();
    }
  }

  if (success) {
    return (
      <div className={styles['reject-security']}>
        <Row>
          <Col lg={12}>
            <div className={styles['success-message']}>
              Successfully rejected
            </div>
          </Col>
        </Row>
        <Row className={styles['button-row']}>
          <Col lg={12}>
            <div className={styles['cancel-button']}>
              <Button variant="secondary" onClick={handleClose}>CLOSE</Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles['reject-security']}>
        <Row>
          <Col lg={12}>
            <div className={styles['error-message']}>
              {error}
            </div>
            <div>
              If problem persists, contact Administrator
            </div>
          </Col>
        </Row>
        <Row className={styles['button-row']}>
          <Col lg={12}>
            <div className={styles['cancel-button']}>
              <Button variant="secondary" onClick={handleClose}>CLOSE</Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className={styles['reject-security']}>
      <Row>
        <Col lg={12}>
          <div className={styles['confirm-message']}>
            Are you sure you want to reject this Sales Report?
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col lg={6}>
          <div className={styles['reject-button']}>
            <Button variant="danger" disabled={loading} onClick={handleReject}>
              {loading ? <Spinner size="sm" animation="border"/> : 'REJECT'}
            </Button>
          </div>
        </Col>
        <Col lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={handleClose}>CANCEL</Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default RejectSalesReportModalContent;
